import * as React from "react"
import { Modal, Col, Row, Spinner, Button, Container, Image, Form, InputGroup } from "react-bootstrap"
import { FaAngleDown } from "react-icons/fa"
import { Typeahead } from "react-bootstrap-typeahead"
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { FilterDataName, GetFilterDataNameIndexByID, DeleteSavedQuery } from "../../api/Randoms/RandomsModel/PoolCriteria"
import { APIError } from "../../api/ObservableFromFetch"
import DeleteQueryImg from '../../assets/images/delete_query.png'
import ConfirmationModal from "../ConfirmationModal"

interface SavedQueriesModalProps {
  savedQueries: FilterDataName[]
  show: boolean
  onSelect: (filterDataId: number, name: string) => void
  onDelete: (filterDataId: number) => void
  onClose: () => void
}

interface SavedQueriesModalState {
  saving: boolean
  showConfirmation: boolean
  idToDelete: number

}

export default class SavedQueriesModal extends React.Component<SavedQueriesModalProps, SavedQueriesModalState> {
  subscription?: Subscription
  state: SavedQueriesModalState = {
    saving: false,
    showConfirmation: false,
    idToDelete: 0
  }

  saveSubscription?: Subscription


  componentWillUnmount() {
    this.saveSubscription && this.saveSubscription.unsubscribe()
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }


  handleClose = () => {
    this.props.onClose()
  }

  handleSelectQuery = (filterDataId: number, name:string) => {
    this.props.onSelect(filterDataId, name)
  }
  handleDeleteQuery = (filterDataId: number) => {
    if (filterDataId <= 0) {
      return
    }
    const itemIndex = GetFilterDataNameIndexByID(this.props.savedQueries, filterDataId);
    if (itemIndex < 0) {
      return
    }
    this.setState({ saving:false, showConfirmation: true, idToDelete: filterDataId })
  }
  deleteSelectedQuery = () => {
    const filterDataId = this.state.idToDelete;
    if (filterDataId <= 0) {
      this.setState({ saving:false, showConfirmation: false, idToDelete: 0 })
      return;
    }
    const itemIndex = GetFilterDataNameIndexByID(this.props.savedQueries, filterDataId);
    if (itemIndex < 0) {
      this.setState({ saving:false, showConfirmation: false, idToDelete: 0 })
      return
    }

    this.setState({ saving: true })

    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveSubscription = DeleteSavedQuery(filterDataId).subscribe(
      data => {
        this.setState({ saving: false })
        this.props.onDelete(filterDataId)
        toast.success("Record deleted successfully.")
      },
      error => this.handleAPIError(error, { saving: false })
    )
    this.closeConfirmation();
  }
  closeConfirmation = () => {
    this.setState({ saving:false, showConfirmation: false, idToDelete: 0 })
  }


  render() {
    const savedQueries = this.props.savedQueries
    return (
      <>
        <ConfirmationModal show={this.state.showConfirmation}
          title=""
          textTitle=""
          text="Are you sure you want to delete this record?"
          showImage={false}
          cancelButtonText="No"
          confirmButtonText="Yes"
          spinConfirmButton={this.state.saving}
          onConfirm={() => this.deleteSelectedQuery()}
          onHide={() => this.closeConfirmation()} />
        <Modal backdrop="static" size="lg" centered show={this.props.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Saved Queries</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {savedQueries.map((savedQuery, i) => {
                return (
                  <Form.Row key={`${savedQuery.FilterDataID}_${i}`}>
                    <Col xs={9}>
                      <Button variant="underline-link" className="px-0 mx-0 " onClick={() => this.handleSelectQuery(savedQuery.FilterDataID, savedQuery.Name)}>{savedQuery.Name}</Button>
                    </Col>
                    <Col xs={3} className="py-2 text-center">
                      <Image src={DeleteQueryImg} title="Delete Query" onClick={() => this.handleDeleteQuery(savedQuery.FilterDataID)} />
                    </Col>
                  </Form.Row>)
              })}           
              </Form>
          </Modal.Body>
          <Modal.Footer>
            {<Button variant="secondary" onClick={() => this.handleClose()}>Cancel</Button>}
          </Modal.Footer>
        </Modal >
      </>
    )
  }
}
